module.exports = __webpack_public_path__ + "img/icon-bookmark-solid.d947314b.png";